var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 7.94922C0.375 7.76367 0.453125 7.59766 0.599609 7.46094L7.12305 0.917969C7.30859 0.732422 7.47461 0.664062 7.65039 0.664062C8.02148 0.664062 8.29492 0.9375 8.29492 1.29883C8.29492 1.48438 8.23633 1.65039 8.11914 1.77734L5.19922 4.72656L2.31836 7.40234L4.58398 7.29492H17.8652C18.2363 7.29492 18.5098 7.56836 18.5098 7.94922C18.5098 8.33008 18.2363 8.60352 17.8652 8.60352H4.58398L2.30859 8.49609L5.19922 11.1719L8.11914 14.1211C8.23633 14.2383 8.29492 14.4141 8.29492 14.5898C8.29492 14.9512 8.02148 15.2246 7.65039 15.2246C7.47461 15.2246 7.31836 15.166 7.17188 15.0293L0.599609 8.4375C0.453125 8.30078 0.375 8.13477 0.375 7.94922Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.ea9242c0.svg";
export { ForwardRef as ReactComponent };